import React, { createContext, useState } from 'react';
import {roomData} from '../data'

export const RoomContext = createContext();

const parseGuestCount = (value) => {
  const match = String(value).match(/\d+/);
  return match ? Number(match[0]) : 0;
};

const RoomProvider = ({children}) => {
  
  const [rooms] = useState(roomData);
  const [adults, setAdults] = useState('1 Adult')
  const [kids, setkids] = useState('0 kids')
  const [roomId, setRoomId] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  
  const [loading, setLoading] = useState(false);
  const [showRoom, setshowRoom] = useState(true);
  const [roomlist, setroomlist] = useState([]);

  const handleClick = (e) =>{
    e.preventDefault();
    const guestCount = parseGuestCount(adults) + parseGuestCount(kids);
    const filteredRooms = roomData.filter((room) => room.maxPerson >= guestCount);

    setLoading(true);
    setroomlist(filteredRooms);
    setshowRoom(false);

    setTimeout(() => {
      setLoading(false);
    }, 600);
  };

  return( 
  <RoomContext.Provider value={{rooms, roomlist, roomId, setRoomId, adults, setAdults, kids, setkids, startDate, setStartDate, endDate, setEndDate, handleClick, loading, showRoom}}>
    {children}  
  </RoomContext.Provider>
  );
};

export default RoomProvider;
